import React from "react";
import { motion } from "framer-motion";
import { SITE } from "@/data/site";

export default function Partners() {
  return (
    <section
      id="partners"
      data-testid="partners-section"
      className="relative bg-[#0B0B0E] py-24 lg:py-32 border-y border-white/[0.05] overflow-hidden"
    >
      <div
        className="absolute -top-40 left-1/3 w-[500px] h-[500px] rounded-full bg-[#F5A623]/[0.04] blur-[140px]"
        aria-hidden
      />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-[#F5A623] font-semibold">
              <span className="divider-gold" /> Premium Partners
            </span>
            <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl silver-text leading-tight tracking-tight">
              Our greatest asset is the happy client.
            </h2>
            <p className="mt-5 inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-[#F5A623] font-semibold border border-[#F5A623]/40 rounded-full px-4 py-2 bg-[#F5A623]/[0.06]">
              Top {SITE.partners.length} Partners <span className="text-[#7A7E88]">·</span> Out of 60+ Partners
            </p>
          </div>
          <div className="text-right shrink-0">
            <p className="font-serif text-5xl lg:text-6xl text-[#F5A623] tabular-nums">
              60+
            </p>
            <p className="text-xs uppercase tracking-[0.22em] text-[#9CA0AA] mt-1">
              Industry partners
            </p>
          </div>
        </div>

        <p className="text-[#B7BBC4] max-w-2xl text-sm lg:text-base mb-10">
          We work with industry-leading carriers and asset managers — so we can recommend what's truly best for you, not what's convenient for us.
        </p>

        {/* White card showing official partner logos */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7 }}
          className="relative bg-white rounded-lg p-6 sm:p-10 lg:p-14 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.6)] ring-1 ring-[#F5A623]/20"
          data-testid="partners-board"
        >
          <img
            src="/partners.jpg"
            alt="Premium partners: TD Asset Management, RBC Insurance, BMO, Manulife Financial, iA Financial Group, ivari, Equitable Life of Canada, Canada Protection Plan, Foresters Financial, Everest Funeral Concierge, Empire Life, La Capitale, B2B Bank, Sirius Benefit Plans, Franklin Templeton Investments, 4 Pillars"
            className="w-full h-auto object-contain"
          />
        </motion.div>

        {/* Hidden but data-testid'd list for testing & SEO */}
        <ul className="sr-only">
          {SITE.partners.map((p) => (
            <li key={p.name} data-testid={`partner-${p.name.toLowerCase().replace(/\W+/g, "-")}`}>
              {p.name}
            </li>
          ))}
        </ul>

        <p className="mt-8 text-xs text-[#7A7E88] text-center">
          Logos and trademarks are property of their respective owners. Inclusion does not imply endorsement.
        </p>
      </div>
    </section>
  );
}
